<template>
  <section id="ecosystem" class="h25-section dark" style="padding-top:60px;padding-bottom:60px">
    <div class="h25-container">
      <div class="h25-sec-hd center">
        <div class="label">Ecosystem</div>
        <h2 style="color:var(--h25-white)">腾讯云核心生态伙伴</h2>
      </div>
      <div class="t-block">
        <h3>腾讯携手创势互联 — 共筑政企AI落地最后一公里</h3>
        <p class="desc">依托腾讯云计算底座与AI基础能力（混元大模型、TI平台、慧眼人脸核身等），创势互联面向园区、制造、政务客户提供场景化SI交付、定制开发、系统集成与持续运维。</p>
        <div class="t-grid">
          <div class="t-card" v-for="card in cards" :key="card.title"><h5>{{ card.title }}</h5><p>{{ card.desc }}</p></div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name:'TencentSection',
  data(){return{cards:[
    {title:'腾讯云基础产品转售 + 集成',desc:'云服务器、COS、CDN、数据库等IaaS/PaaS转售，联合方案集成与架构优化'},
    {title:'腾讯优图AI原子能力场景封装',desc:'人脸核身、OCR识别等优图AI能力封装为政企可落地的场景化方案'},
    {title:'企业微信 + 政务微信集成',desc:'基于企业微信/政务微信的OA、审批、即时通讯等定制开发与实施部署'},
    {title:'腾讯千帆SaaS生态落地',desc:'联合腾讯千帆计划引入优质SaaS产品，本地化实施与交付，快速响应终端客户'}
  ]}}
}
</script>
<style scoped>
.t-block{background:var(--h25-text);color:var(--h25-white);border-radius:var(--h25-radius);padding:48px 44px}
.t-block h3{font-size:21px;font-weight:700;margin-bottom:12px;color:var(--h25-accent)}
.desc{font-size:14px;opacity:.55;margin-bottom:32px;max-width:700px;line-height:1.9}
.t-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(260px,1fr));gap:16px}
.t-card{background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.07);border-radius:var(--h25-radius);padding:24px}
.t-card h5{font-size:14px;font-weight:700;margin-bottom:8px;color:var(--h25-accent)}
.t-card p{font-size:13px;opacity:.5;line-height:1.8}
@media(max-width:768px){.t-block{padding:32px 24px}}
</style>
